module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M21.074 0H3.15C1.238 0 0 1.348 0 2.466V30.85c0 1.122.86 1.482 1.92.812L12 25.278l10.08 6.386c1.06.67 1.92.308 1.92-.812V2.466C24 .982 23.026 0 21.074 0zm-1.242 11.606l-4.09 4.424 1.598 5.334c.12.4.028.636-.21.636a.662.662 0 0 1-.326-.106L12 19.196l-4.746 2.696a.696.696 0 0 1-.328.108c-.238 0-.332-.234-.214-.636l1.546-5.332-4.09-4.426c-.322-.456-.168-.826.352-.826l4.676-.03 2.324-4.374c.132-.25.304-.376.48-.376s.348.126.48.376l2.324 4.374 4.676.03c.52 0 .674.37.352.826z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bookmark-3.js
// module id = 1022
// module chunks = 14